;(function () {
  'use strict'

  angular
    .module('contrast.integrations')
    .factory('rulesBugtrackerService', rulesBugtrackerServiceFactory)

  function rulesBugtrackerServiceFactory(
    RuleFactory,
    ServiceUtils,
    FILTER_GROUPS,
    RULE_SEVERITY_LIST
  ) {
    'ngInject'

    return {
      getRules: getRules,
      buildRules: buildRules,
      buildRulesWithAllSeverities: buildRulesWithAllSeverities,
      buildRulesWithDefaultSeverities: buildRulesWithDefaultSeverities,
      transformRulesToIntegrationView: transformRulesToIntegrationView
    }

    function getRules() {
      return RuleFactory.getRulesBase()
        .then(ServiceUtils.handleResolve('data.rules'))
        .catch(ServiceUtils.handleError)
    }

    function _getAllSeverities() {
      var severities = angular.copy(RULE_SEVERITY_LIST)
      _.each(severities, function (element) {
        _.extend(element, { group: FILTER_GROUPS.SEVERITY })
      })

      return severities
    }

    function buildRules(rules, severities) {
      var transformedRules = []

      var i = 0

      //add severities
      var severity
      for (; i < severities.length; i++) {
        severity = severities[i]

        var severityAsRule = _.find(_getAllSeverities(), function (item) {
          return item.value === severity
        })

        if (severityAsRule) {
          transformedRules.push({
            name: severityAsRule.name,
            value: severityAsRule.value,
            group: FILTER_GROUPS.SEVERITY
          })
        }
      }

      i = 0

      //add rules
      var rule
      for (; i < rules.length; i++) {
        rule = rules[i]
        //the rules translationId will not get translated by angular
        transformedRules.push({
          name: rule.title,
          value: rule.name,
          group: FILTER_GROUPS.VULNERABILITY_RULES,
          translationId: rule.title
        })
      }

      return transformedRules
    }

    function buildRulesWithAllSeverities(rules) {
      var transformedRules = _getAllSeverities()
      var i = 0
      var rule
      for (; i < rules.length; i++) {
        rule = rules[i]
        transformedRules.push({
          name: rule.title,
          value: rule.name,
          group: FILTER_GROUPS.VULNERABILITY_RULES,
          translationId: rule.title
        })
      }

      return transformedRules
    }

    function buildRulesWithDefaultSeverities() {
      var defaultSeverities = []
      defaultSeverities.push({
        name: RULE_SEVERITY_LIST[0].name,
        value: RULE_SEVERITY_LIST[0].value,
        group: FILTER_GROUPS.SEVERITY,
        translationId: RULE_SEVERITY_LIST[0].name
      })
      defaultSeverities.push({
        name: RULE_SEVERITY_LIST[1].name,
        value: RULE_SEVERITY_LIST[1].value,
        group: FILTER_GROUPS.SEVERITY,
        translationId: RULE_SEVERITY_LIST[1].name
      })

      return defaultSeverities
    }

    function transformRulesToIntegrationView(integration, rules, form) {
      _pushRulesToForm(integration, rules, form)
    }

    function _pushRulesToForm(integration, rules, form) {
      var i, rule, objectItem

      for (i = 0; i < integration.auto_create_tickets_rules.length; i++) {
        rule = integration.auto_create_tickets_rules[i]
        objectItem = _.find(rules, function (item) {
          return item.value === rule.value
        })

        if (objectItem) {
          form.auto_create_tickets_rules.push(objectItem)
        }
      }
    }
  }
})()
